import { Panel, Row, Segmented, Switch } from './ui';
import { COUNTDOWN_OPTIONS, FPS_OPTIONS, QUALITY_OPTIONS, type Settings } from '../settings';

export function CapturePanel({
  settings,
  update,
  busy,
}: {
  settings: Settings;
  update: (patch: Partial<Settings>) => void;
  busy: boolean;
}) {
  return (
    <Panel label="Capture">
      <Row label="Frame rate" hint="Screen content looks best at 60">
        <Segmented
          name="Frame rate"
          value={settings.fps}
          onChange={(value) => update({ fps: value })}
          options={FPS_OPTIONS.map((fps) => ({ value: fps as number, label: `${fps}` }))}
        />
      </Row>
      <Row label="Quality" hint="Bitrate for the H.264 encode">
        <Segmented
          name="Quality"
          value={settings.quality}
          onChange={(value) => update({ quality: value })}
          options={QUALITY_OPTIONS}
        />
      </Row>
      <Row label="Pre-roll" hint="Countdown before capture starts">
        <Segmented
          name="Pre-roll"
          value={settings.countdownMs}
          onChange={(value) => update({ countdownMs: value })}
          options={COUNTDOWN_OPTIONS}
        />
      </Row>
      <Row
        label="Hide this tab"
        hint={
          settings.hideOwnTab
            ? 'The picker leaves this tab out, so the recorder never films itself'
            : 'This tab is offered as a capture source'
        }
      >
        <Switch
          label="Hide this tab from the picker"
          checked={settings.hideOwnTab}
          onChange={(value) => update({ hideOwnTab: value })}
          disabled={busy}
        />
      </Row>
    </Panel>
  );
}
